<script>
    /** @type {string} */
    export let title = undefined;
    /** @type {string} */
    export let description = undefined;
    /** @type {'horizontal'|'vertical'} */
    export let orientation = 'vertical';
    /** @type {boolean} */
    export let disabled = false;
    /** @type {string} */
    export let cssClass = '';
</script>

<fieldset class="prom-form-section" class:prom-form-section--has-legend={!!title} {disabled}>
    {#if title}
        <legend class="prom-form-section__legend">
            <span class="prom-form-section__legend-title">{title}</span>
            {#if description}
                <span class="screen-reader">.</span>
                <span class="prom-form-section__legend-description">{description}</span>
            {/if}
        </legend>
    {/if}

    <div class="prom-form-section__container prom-form-section__container--{orientation} {cssClass}">
        <slot />
    </div>
</fieldset>
